// extracted by mini-css-extract-plugin
export default {"selected_algin":"dropDown_selected_algin__wQL7R","dropdown_list_container":"dropDown_dropdown_list_container__TZFMZ","drop_down_layer":"dropDown_drop_down_layer__Mjpm9"};